import { IIconProps } from "../types"

export default function IconLR4(props: IIconProps) {
  const width = props.size || props.width || (94 / 5) * 3
  const height = props.size || props.height || (111 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 94 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.0651 2.36182C41.523 0.392449 46.1915 -0.0474098 50.76 1.00225C55.3386 2.06191 59.8071 4.6111 64.3757 7.20027C68.9442 9.78944 73.6227 12.4286 77.6314 15.0677C81.6501 17.6969 84.9991 20.3361 87.4383 22.5354C89.8775 24.7346 91.397 26.4841 92.2567 29.6931C93.1264 32.902 93.3264 37.5605 92.5666 43.6686C91.8069 49.7766 90.0774 57.3242 87.2883 65.7615C84.4892 74.1988 80.6305 83.5158 77.2215 90.4536C73.8226 97.4014 70.8736 101.97 67.0648 104.999C63.256 108.028 58.5875 109.527 53.2992 109.617C48.0209 109.697 42.1228 108.388 37.3543 106.279C32.5759 104.169 28.917 101.27 25.4182 96.2517C21.9093 91.2433 18.5604 84.1256 14.9015 75.0785C11.2427 66.0314 7.28397 55.0449 4.64481 46.8775C2.00566 38.7002 0.686083 33.3419 0.47615 28.9033C0.276214 24.4647 1.18592 20.9559 3.32524 18.1867C5.45455 15.4176 8.80348 13.3983 14.6016 10.6292C20.3898 7.86005 28.6171 4.34118 35.0651 2.36182Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
